"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _pollerService = _interopRequireDefault(require("./pollerService"));

var _pollerActionKeys = require("./pollerActionKeys");

var _default = _reduxActions.createActions.apply(void 0, [(0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG, function (senderEntityId) {
  return {
    promise: _pollerService.default.getConfig(senderEntityId)
  };
})].concat([_pollerActionKeys.START_POLLING, _pollerActionKeys.STOP_POLLING, _pollerActionKeys.STOP_ALL_POLLING]));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/poller/pollerActions.js
// module id = 1392
// module chunks = 25